// Aynı işlem firma için "tahsilat", cari (bayi) için "ödeme"dir. Ekran metinleri
// kullanıcının rolüne göre bu sözcüklerle kurulur (kenar çubuğuyla aynı kural).
const ODEME = {
    Word: "Ödeme", word: "ödeme",
    Plural: "Ödemeler", plural: "ödemeler",
    accusative: "ödemeyi", ablative: "ödemeden",
};

const TAHSILAT = {
    Word: "Tahsilat", word: "tahsilat",
    Plural: "Tahsilatlar", plural: "tahsilatlar",
    accusative: "tahsilatı", ablative: "tahsilattan",
};

export const PAYER_WORDS = ODEME;

export const getPaymentWords = (roles) =>
    (roles || []).some(r => r.startsWith("ROLE_ACCOUNT_")) ? ODEME : TAHSILAT;
